import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import Calendar from "./Calendar";
import Header from "./Header";
import Filters from "./Filters";
import {
  selectSector,
  selectPdc,
  isLoading,
  setCurrentFilters,
  getAllSectorsList,
  setCurrentDateRange,
  setPlanningSelectedDate
} from "./../../../redux/actions/planningActions";

import { PLANNING_PRE_SELECT_USER } from "../../../redux/types";
import moment from "moment-timezone";

import {
  selectPlanningCurrentDateRange,
  selectPlanningDate,
  selectPlanningEmail
} from "../../../redux/selectors/planningSelector";
import { Button } from "antd";
import { exportEvents } from "./Events.util";
import { Link } from "react-router-dom";

const CalendarContainer = ({
  preSelectUser,
  getAllSectorsList,
  setCurrentDateRange,
  selectedEmail,
  selectedDate,
  currentDateRange,
  updateSelectedDate,
  token,
  client_id,
  role_id
}) => {
  const [areIndicatorsVisible, setAreIndicatorsVisible] = useState(true);
  const [displayMode, setDisplayMode] = useState("calendar");
  const updateCurrentDateRange = (startDate, endDate) => {
    if (currentDateRange.start !== startDate && currentDateRange.end !== endDate) {
      const newRange = {
        start: startDate,
        end: endDate
      };

      const selectedDateTimestamp = selectedDate.valueOf();

      setCurrentDateRange(newRange);

      if (startDate > selectedDateTimestamp || endDate < selectedDateTimestamp) {
        updateSelectedDate(startDate);
      }
    }
  };
  useEffect(() => {
    preSelectUser();
    if (selectedEmail === null) getAllSectorsList();
  }, []);

  let fullWidth = !areIndicatorsVisible ? "p-content-page-center-full" : "";
  let indicatorBtn = !areIndicatorsVisible ? "p-btn-blue" : "p-btn-blue";
  const isClient = role_id === 5;
  if (isClient) {
    return (
      <div
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "15px"
        }}
      >
        <Link
          to="/visit"
          style={{
            padding: "15px 20px",
            backgroundColor: "#1890ff",
            color: "white",
            borderRadius: "6px",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            width: "100%"
          }}
        >
          <span style={{ marginRight: "10px" }}>📋</span>
          Lien vers la page Visites
        </Link>
        <Link
          to="/phototheque"
          style={{
            padding: "15px 20px",
            backgroundColor: "#1890ff",
            color: "white",
            borderRadius: "6px",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            width: "100%"
          }}
        >
          <span style={{ marginRight: "10px" }}>🖼️</span>
          Lien vers la Galerie Photos
        </Link>
        <Link
          to="/stats"
          style={{
            padding: "15px 20px",
            backgroundColor: "#1890ff",
            color: "white",
            borderRadius: "6px",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            width: "100%"
          }}
        >
          <span style={{ marginRight: "10px" }}>📊</span>
          Lien vers les Statistiques
        </Link>
      </div>
    );
  }
  if (selectedEmail === null) return <div>Pas d'utilisateur avec un secteur pour ce dossier</div>;
  const endRangeDateDisplay =
    moment(currentDateRange.end).format("DD-MM-YYYY") === moment(selectedDate).format("DD-MM-YYYY")
      ? ""
      : `au ${moment(currentDateRange.end).format("DD-MM-YYYY")}`;

  return (
    <Fragment>
      <div className={`p-content-page-center ${fullWidth}`}>
        <div className="p-content-page-center-header">
          <h2 className="p-content-page-center-header-title">{`Planning du ${moment(selectedDate).format(
            "DD-MM-YYYY"
          )} ${endRangeDateDisplay}`}</h2>
          <Button
            type="primary"
            onClick={async () => {
              await exportEvents(token, client_id);
            }}
          >
            {`Télécharger les événements de type Speedy/Admin`}
          </Button>
          <div className="p-content-page-center-header-buttons">
            <div className="p-content-page-center-header-buttons-item">
              {displayMode === "calendar" && (
                <div
                  className={`p-content-page-center-header-buttons-item p-btn p-indicators ${indicatorBtn}`}
                  onClick={() => setAreIndicatorsVisible(s => !s)}
                >
                  {areIndicatorsVisible ? (
                    <Fragment>
                      <span className="icon-arrow-right p-mrg-right-s" style={{ color: "#fff" }} /> Cacher les
                      indicateurs
                    </Fragment>
                  ) : (
                    <Fragment>
                      <span className="icon-arrow-left p-mrg-right-s" style={{ color: "#fff" }} /> Afficher les
                      indicateurs
                    </Fragment>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="p-content-page-center-filters">
          <Filters />
        </div>
        <div className="p-content-page-center-content">
          <Calendar
            {...this.props}
            updateCurrentDateRange={updateCurrentDateRange}
            displayMode={displayMode}
            setDisplayMode={setDisplayMode}
          />
        </div>
      </div>
      {displayMode === "calendar" && areIndicatorsVisible ? (
        <div className="p-content-page-right">
          <h3 className="p-content-page-right-title">Évènements :</h3>
          <Header />
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = state => {
  const selectedPlanningEmail = selectPlanningEmail(state);

  return {
    selectedEmail: selectedPlanningEmail,
    selectedDate: selectPlanningDate(state),
    currentDateRange: selectPlanningCurrentDateRange(state),
    token: state.auth.token,
    client_id: state.currentClient.id,
    role_id: state.userInfos.role_id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllSectorsList: () => dispatch(getAllSectorsList()),
    isLoading: value => dispatch(isLoading(value)),
    selectSector: sector => dispatch(selectSector(sector)),
    selectPdc: pdc => dispatch(selectPdc(pdc)),
    setCurrentFilters: () => dispatch(setCurrentFilters({})),
    preSelectUser: () => dispatch({ type: PLANNING_PRE_SELECT_USER }),
    updateSelectedDate: date => dispatch(setPlanningSelectedDate(date)),
    setCurrentDateRange: range => dispatch(setCurrentDateRange(range))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarContainer);



// WEBPACK FOOTER //
// src/containers/activite/planning/index.js